<template>
  <div class="trbo-a-question-avatar">
    <img :src="imageUrl" alt="avatar" class="trbo-a-question-avatar__image">
    <div class="trbo-a-question-avatar__name">
      {{ name }}
    </div>
  </div>
</template>

<script>
// @flow

export default {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped src="./question-avatar.scss" />
